import React, { Component, Fragment } from 'react'
import TopNavigation from '../components/TopNavigation/header';
import PageTop from '../components/PageTop/PageTop';
import Footer from '../components/Footer/Footer';
import AllCources from '../components/AllCourses/AllCources';
//----------------Elplore Our Event page like summer winter eid Events------------
export class AllCoursePage extends Component {
  componentDidMount(){
    window.scroll(0,0);
  }

  render() {
    return (
     <Fragment>
        <TopNavigation></TopNavigation>
        <PageTop pageTitle="Explore Our Events"></PageTop>
        <AllCources></AllCources>
        <Footer></Footer>
     </Fragment>
    )
  }
}

export default AllCoursePage
